export default defineComponent({
  props: {
    metricAssignment: {
      type: Object,
      required: true
    }
  }
});